import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { daysFromNow } from '@zapier/date';
import { useIsAuthenticated } from '@zapier/design-system-revenue/src/hooks';

import { professionalTrialEndedBanner_currentAccountQuery as CurrentAccountQuery } from './types/professionalTrialEndedBanner_currentAccountQuery';

export const currentAccountQuery = gql`
  query professionalTrialEndedBanner_currentAccountQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      isTrialing
      trialEndDate
      plan: planV2 {
        amount
        id
      }
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useShouldRender = ({ skip }: Props = {}) => {
  const { isAuthenticated } = useIsAuthenticated();

  const accountId = localStorage.getItem('currentAccountId');

  const { data } = useQuery<CurrentAccountQuery>(currentAccountQuery, {
    skip: skip || !isAuthenticated || !accountId,
    variables: {
      accountId: parseInt(accountId ?? ''),
    },
  });

  const account = data?.account;

  const daysSinceTrialEnded = account?.trialEndDate
    ? daysFromNow(account?.trialEndDate)
    : 0;

  return (
    !account?.isTrialing &&
    !!account?.trialEndDate &&
    account?.plan?.amount === 0 &&
    daysSinceTrialEnded <= 14
  );
};
